module.exports = __webpack_public_path__ + "img/maleta.824fed5c.png";